import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';

export interface IBlockComponentConfiguration extends CM.DOMComponent.IConfiguration {
	tag?: string;
};

export class BlockComponent<
	TComponent extends BlockComponent<any, any> = BlockComponent<any>,
	TBlockComponentConfiguration extends IBlockComponentConfiguration = IBlockComponentConfiguration
> extends CM.DOMComponent<
	HTMLElement,
	TComponent,
	TBlockComponentConfiguration
> {
	component_DOM: HTMLElement;

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: TBlockComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLElement>STD.DOM.factory({ tag: configuration.tag || 'div' });
	};
};
export namespace NS {
	export const Component = BlockComponent;
	export type Component = BlockComponent<any>;
	export type Configuration = IBlockComponentConfiguration;
}
;
CM.Manager.declare({
	id: 'block',
	type: BlockComponent
});
